export const menuItems = [
    {
        id: 0,
        src: "/gallery/choco-latte.jpeg",
        itemName: "Choco Latte",
        altText: "Choco Latte",
        desc:
            "Lorem, ipsum dolor sit amet consectetur adipisicing elit. Harum quia modi",
    },
    {
        id: 1,
        src: "/gallery/choco-ube-slush.jpg",
        itemName: "Choco Ube Slush",
        altText: "Choco Ube Slush",
        desc:
            "Lorem, ipsum dolor sit amet consectetur adipisicing elit. Harum quia modi",
    },
    {
        id: 2,
        src: "/gallery/cinnamon-swirl-slush.jpg",
        itemName: "Cinnamon Swirl Slush",
        altText: "Cinnamon Swirl Slush",
        desc:
            "Lorem, ipsum dolor sit amet consectetur adipisicing elit. Harum quia modi",
    },
    {
        id: 3,
        src: "/gallery/iced-coffee.jpg",
        itemName: "Iced Coffee",
        altText: "Iced Coffee",
        desc:
            "Lorem, ipsum dolor sit amet consectetur adipisicing elit. Harum quia modi",
    },
    {
        id: 4,
        src: "/gallery/iced-tea-lemon.jpeg",
        itemName: "Lemon Iced Tea",
        altText: "Lemon Iced Tea",
        desc:
            "Lorem, ipsum dolor sit amet consectetur adipisicing elit. Harum quia modi",
    },
    {
        id: 5,
        src: "/gallery/match-green.jpg",
        itemName: "Matcha Green Tea",
        altText: "Matcha Green Tea",
        desc:
            "Lorem, ipsum dolor sit amet consectetur adipisicing elit. Harum quia modi",
    },
    {
        id: 6,
        src: "/gallery/matcha-latte.jpg",
        itemName: "Matcha Latte",
        altText: "Matcha Latte",
        desc:
            "Lorem, ipsum dolor sit amet consectetur adipisicing elit. Harum quia modi",
    },
    {
        id: 7,
        src: "/gallery/milk-tea.jpg",
        itemName: "Milk Tea",
        altText: "Milk Tea",
        desc:
            "Lorem, ipsum dolor sit amet consectetur adipisicing elit. Harum quia modi",
    },
    {
        id: 8,
        src: "/gallery/oreo-slush.jpeg",
        itemName: "Oreo Slush",
        altText: "Oreo Slush",
        desc:
            "Lorem, ipsum dolor sit amet consectetur adipisicing elit. Harum quia modi",
    },
    {
        id: 9,
        src: "/gallery/strawberry-passion.webp",
        itemName: "Strawberry Passion Tea",
        altText: "Strawberry Passion Tea",
        desc:
            "Lorem, ipsum dolor sit amet consectetur adipisicing elit. Harum quia modi",
    },
    {
        id: 10,
        src: "/gallery/strawberry-peach-lemonade.jpeg",
        itemName: "Strawberry Peach Lemonade",
        altText: "Strawberry Peach Lemonade",
        desc:
            "Lorem, ipsum dolor sit amet consectetur adipisicing elit. Harum quia modi",
    },
    {
        id: 11,
        src: "/gallery/thai-tea.jpeg",
        itemName: "Thai Tea",
        altText: "Thai Tea",
        desc:
            "Lorem, ipsum dolor sit amet consectetur adipisicing elit. Harum quia modi",
    },
];
